var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.742C24 5.25705 18.6274 0 12 0C5.37258 0 0 5.25705 0 11.742C0 17.6026 4.3882 22.4604 10.125 23.3413V15.1361H7.07812V11.742H10.125V9.15507C10.125 6.21224 11.9166 4.58671 14.6576 4.58671C15.9705 4.58671 17.3438 4.81604 17.3438 4.81604V7.70567H15.8306C14.34 7.70567 13.875 8.61086 13.875 9.53943V11.742H17.2031L16.6711 15.1361H13.875V23.3413C19.6118 22.4604 24 17.6029 24 11.742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhiteLogo);
export default __webpack_public_path__ + "static/media/facebook-white-logo.2a39ec6e75596a65dea2e5947952538f.svg";
export { ForwardRef as ReactComponent };